import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=50d04680&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d04680')) {
      api.createRecord('50d04680', component.options)
    } else {
      api.reload('50d04680', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=50d04680&", function () {
      api.rerender('50d04680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fnh8Ndvy0N7K/JS/comp/childrenage.vue"
export default component.exports